import React, { Component } from 'react';
import { Container, Row } from 'reactstrap';

class NotFoundComponent extends Component {
  render() {
    return (
      <Container className="bg-white">
        <Row>
          <h4>Page Not Found</h4>
        </Row>
      </Container>
    );
  }
}
export default NotFoundComponent;



// WEBPACK FOOTER //
// ./src/Components/ErrorComponents/NotFoundComponent.js